export class DynamicPageBaseComponentModel {
  constructor(c = {}, type) {
    this.type = type
    this.id = c.id
    this.index = c.index
  }
}
